import {
  BOT_SPEED_PRESETS,
  MAX_BOT_SPEED_MS,
  MIN_BOT_SPEED_MS,
  useGameStore,
} from '../../store/gameStore';

const PRESET_OPTIONS = [
  { id: 'slow' as const, label: '느림', ms: BOT_SPEED_PRESETS.slow },
  { id: 'normal' as const, label: '보통', ms: BOT_SPEED_PRESETS.normal },
  { id: 'fast' as const, label: '빠름', ms: BOT_SPEED_PRESETS.fast },
];

export function BotSpeedControl() {
  const botSpeedMs = useGameStore((s) => s.botSpeedMs);
  const setBotSpeedMs = useGameStore((s) => s.setBotSpeedMs);

  const activePreset = PRESET_OPTIONS.find((p) => p.ms === botSpeedMs)?.id;

  return (
    <div>
      <p className="mb-2 text-xs text-white/60">AI 속도 · {botSpeedMs}ms</p>
      <div className="mb-2 flex gap-2">
        {PRESET_OPTIONS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            className={`min-h-[44px] flex-1 touch-manipulation rounded-lg text-xs font-semibold transition ${
              activePreset === preset.id
                ? 'bg-amber-400 text-black'
                : 'bg-white/5 text-white/80 hover:bg-white/10'
            }`}
            onClick={() => setBotSpeedMs(preset.ms)}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <input
        type="range"
        min={MIN_BOT_SPEED_MS}
        max={MAX_BOT_SPEED_MS}
        step={50}
        value={botSpeedMs}
        onChange={(e) => setBotSpeedMs(Number(e.target.value))}
        className="w-full touch-manipulation"
        style={{ fontSize: 16 }}
        aria-label="AI 속도 조절"
      />
    </div>
  );
}
